import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import h from 'react-hyperscript';
import './Dropdown.scss';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';
import LinkIcon from '@material-ui/icons/Link';
import {h4} from 'Components/Typography/Typography';

export default function Dropdown(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    h('div', [
      h(ListItem, {onClick: handleClick, className: 'report-dropdown'},
          [
            h(ListItemText, {
            }, [
              h(h4, props.reportCardName),
            ]),
            Boolean(anchorEl) ? h(ArrowDropUpIcon) : h(ArrowDropDownIcon),
          ]
      ),
      h(Menu, {
        timeout: 'auto',
        anchorEl: anchorEl,
        keepMounted: true,
        elevation: 1,
        getContentAnchorEl: null,
        open: Boolean(anchorEl),
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        onClose: handleClose,
      }, [
        h(MenuItem, {
          button: true,
          onClick: () => {
            props.openShareModal();
            handleClose();
          },
          className: 'dropdown__menu-item',
        }, [
          h(ListItemIcon, {className: 'dropdown__icon'}, [
            h(PersonAddOutlinedIcon),
          ]),
          h(ListItemText, {
            primary: 'Share',
          }),
        ]),
        h(MenuItem, {
          button: true,
          onClick: () => {
            props.openShareLinkModal();
            handleClose();
          },
          className: 'dropdown__menu-item',
        }, [
          h(ListItemIcon, {className: 'dropdown__icon'}, [
            h(LinkIcon),
          ]),
          h(ListItemText, {
            primary: 'Get shareable link',
          }),
        ]),
        h(MenuItem, {
          button: true,
          onClick: (e) => {
            props.downloadReport(e);
            handleClose();
          },
          className: 'dropdown__menu-item',
        }, [
          h(ListItemIcon, {className: 'dropdown__icon'}, [
            h(GetAppIcon),
          ]),
          h(ListItemText, {
            primary: 'Download PDF',
          }),
        ]),
      ]),
    ])
  );
}
